import React from 'react';
import { BrowserRouter, Link, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import ArticleView from './pages/ArticleView';
import CategoryPage from './pages/CategoryPage';
import SearchPage from './pages/SearchPage';
import TagPage from './pages/TagPage';
import NotFoundPage from './pages/NotFoundPage';
import AdminIndex from './pages/AdminIndex';
import DebugCovers from './pages/DebugCovers';
function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-[#4F46E5] selection:text-white">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/a-la-une" element={<CategoryPage forcedSlug="a-la-une" />} />
            <Route path="/categorie/:slug" element={<CategoryPage />} />
            <Route path="/bons-plans" element={<CategoryPage forcedSlug="bons-plans" />} />
            <Route path="/article/:slug" element={<ArticleView />} />
            <Route path="/recherche" element={<SearchPage />} />
            <Route path="/tags/:tag" element={<TagPage />} />
            <Route path="/admin" element={<AdminIndex />} />
            <Route path="/debug/covers" element={<DebugCovers />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        
        <footer className="mt-20 bg-[#111827] py-16 text-white">
          <div className="container mx-auto px-4">
            <div className="mb-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
              <div>
                <h2 className="text-xl font-black uppercase tracking-tight md:text-2xl">LMD - Le Vrai Journal du Digital</h2>
                <p className="mt-4 max-w-sm text-sm leading-relaxed text-gray-300">
                  Le média qui explique le digital autrement.
                  <br />
                  Analyses, décryptages, opportunités.
                </p>
              </div>

              <div>
                <h4 className="mb-4 text-sm font-bold uppercase tracking-wider text-gray-200">Catégories</h4>
                <ul className="space-y-2 text-sm text-gray-300">
                  <li><Link to="/categorie/ia" className="hover:text-white">IA</Link></li>
                  <li><Link to="/categorie/business-opportunites" className="hover:text-white">Business & opportunités</Link></li>
                  <li><Link to="/categorie/aides-financements" className="hover:text-white">Aides & financements</Link></li>
                  <li><Link to="/categorie/marketing-seo" className="hover:text-white">Marketing & SEO</Link></li>
                  <li><Link to="/categorie/analyses-opinions" className="hover:text-white">Analyses & opinions</Link></li>
                  <li><Link to="/categorie/actu-rapide" className="hover:text-white">Actu rapide</Link></li>
                  <li><Link to="/categorie/bons-plans" className="hover:text-white">Bons plans</Link></li>
                </ul>
              </div>

              <div>
                <h4 className="mb-4 text-sm font-bold uppercase tracking-wider text-gray-200">Contact</h4>
                <ul className="space-y-2 text-sm text-gray-300">
                  <li><a href="mailto:contact@lemeilleurdu.digital" className="hover:text-white">contact@lemeilleurdu.digital</a></li>
                  <li><a href="mailto:contact@lemeilleurdu.digital?subject=Proposer%20un%20sujet" className="hover:text-white">Proposer un sujet</a></li>
                  <li><a href="mailto:contact@lemeilleurdu.digital?subject=Partenariats" className="hover:text-white">Partenariats</a></li>
                </ul>
              </div>

              <div>
                <h4 className="mb-4 text-sm font-bold uppercase tracking-wider text-gray-200">Légal</h4>
                <ul className="space-y-2 text-sm text-gray-300">
                  <li><a href="#" className="hover:text-white">Mentions légales</a></li>
                  <li><a href="#" className="hover:text-white">Politique de confidentialité</a></li>
                </ul>
              </div>
            </div>

            <div className="border-t border-gray-800 pt-8 text-center text-sm text-gray-500">
              &copy; {new Date().getFullYear()} LMD - Le Vrai Journal du Digital. Tous droits réservés.
            </div>
          </div>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;